import React, { useContext, useEffect, useState } from 'react';
import { Button, Collapse, Form, OverlayTrigger, Tabs, Tab } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { LS_AUTHORITY_KEY } from '../../../core/constants/common';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import { LoaderContext } from '../../../App';
import { toast } from "react-toastify";
import { BsInfoCircle, BsCheckCircle, BsXCircle } from "react-icons/bs";
import Utils from '../../../core/utilities/Utils';

const UAEFDLOprBoundaries = ({ t, filterData, nextPage, prevPage, setHasUnsavedData, registerSaveHandler, gotoPage }) => {
    const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
    const companyId = lsDat.profile.company.id;
    const [scopes, setScopes] = useState([]);
    const [scopeDisplay, setScopeDisplay] = useState([]);
    const { setLoaderDisplay } = useContext(LoaderContext);
    const [hasUnsavedData, setLocalHasUnsavedData] = useState(false);
    const [hasAnswered, setHasAnswered] = useState(false);

    useEffect(() => {
        getScopesData();
    }, [filterData])

    useEffect(() => {
        if (registerSaveHandler) {
            registerSaveHandler((nav) => saveOprBoundaries(nav));
        }
    }, [scopes, filterData]);

    const getScopesData = () => {
        setLoaderDisplay(true);
        const date = filterData?.year + '-01-01';
        GHGEmissionService.getScopesDataSet(companyId, date)
            .then((response) => {
                setLoaderDisplay(false);
                let data = response.data.data;
                setScopes(data);
                setHasAnswered(hasAnsweredQuestions(data));
                setLocalHasUnsavedData(false);
                setHasUnsavedData(false);
            })
            .catch((error) => {
                setLoaderDisplay(false);
            });
    }

    const hasAnsweredQuestions = (data) => {
        for (const scope of data) {
            for (const category of scope.categories) {
                for (const question of category.questions) {
                    if (question.answer === "Yes" || question.answer === "No") {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    const allQuestionsAnswered = (data) => {
        for (const category of data.categories) {
            for (const question of category.questions) {
                if (question.answer !== "Yes" && question.answer !== "No") {
                    return false;
                }
            }
        }
        return true;
    };

    const saveOprBoundaries = async (nav) => {
        let passData = [];
        let nodatafound = false;
        let allNoAnswers = true;

        scopes.forEach(scope => {
            scope.categories.forEach(cat => {
                cat.questions.forEach(qn => {
                    if (qn.answer == null) {
                        nodatafound = true;
                        return;
                    }
                    if (qn.answer === "Yes") {
                        allNoAnswers = false;
                    }
                    passData.push({
                        questionId: qn.id,
                        answer: qn.answer
                    });
                })
            });
        });

        if (nodatafound) {
            toast.warning(t('PleaseAnswerAllQuestionsInSection.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            return false;
        } else if (allNoAnswers) {
            toast.warning(t('PleaseSelectAtLeastOneYes.label'), {
                position: toast.POSITION.TOP_RIGHT,
            });
            return false;
        } else {
            setLoaderDisplay(true);
            const date = filterData?.year + '-01-01';
            try {
                const response = await GHGEmissionService.saveOprBoundaries(date, companyId, passData);
                setLoaderDisplay(false);
                if (response.status !== 200) return false;
                toast.success(t('OperationalBoundariesSavedSuccess.label'), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLocalHasUnsavedData(false);
                setHasUnsavedData(false);
                if (nav == 'next') {
                    nextPage('EmiSource');
                } else if (nav == 'back') {
                    prevPage('Org');
                }
                return true;
            } catch (error) {
                setLoaderDisplay(false);
                return false;
            }
        }
    }

    const setAnswers = (scopeIndex, catIndex, qnIndex, answer) => {
        let temp = JSON.parse(JSON.stringify(scopes));
        temp[scopeIndex].categories[catIndex].questions[qnIndex].answer = answer;
        setScopes(temp);
        setLocalHasUnsavedData(true);
        setHasUnsavedData(true);
    }

    return (
        <div className='GHGOprBoundaries'>
            <div className='GHGOprBoundaries_Row row m-0'>
                <div className='col-lg-9 p-2'>
                    <div className='text-center pt-2'>{t('OprBoundaryHead.label')}</div>
                    <div className='card  mt-3'>
                        <Tabs id="uncontrolled-tab-example">
                            {
                                scopes?.map((scope, scopeIndex) => {
                                    return (
                                        <Tab eventKey={scope.id} title={
                                            <>
                                                {allQuestionsAnswered(scope) && <BsCheckCircle className='me-2' />}
                                                {!allQuestionsAnswered(scope) && <BsXCircle className='me-2' style={{ color: 'red' }} />}
                                                {scope.name}
                                            </>
                                        } >
                                            <div className="GHGOprBoundaries_body card-body p-3 pt-0">
                                                <p className='description01' >{scope.description}</p>
                                                {
                                                    scope.categories?.map((cat, catIndex) => {
                                                        return (
                                                            <div className='GHGOprBoundaries_inner' key={cat.id}>
                                                                <h6 className="mb-0">
                                                                    {cat.name}

                                                                    <OverlayTrigger
                                                                        placement="top"
                                                                        overlay={Utils.renderTooltip(cat.description)}>
                                                                        <span>
                                                                            <BsInfoCircle className='cursor ms-2' />
                                                                        </span>
                                                                    </OverlayTrigger>
                                                                </h6>
                                                                {
                                                                    cat.questions?.map((qn, qnIndex) => {
                                                                        return (
                                                                            <div className='GHGOprBoundaries_inner02' key={qn.id}>
                                                                                <p className="mb-0" key={qn.id}>{qn.question}</p>
                                                                                <div className='OprBoundary_check'>
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label={t("Yes.label")}
                                                                                        name={`qn-${qn.id}`}
                                                                                        type="radio"
                                                                                        id={`inline-radio-${qn.id}-1`}
                                                                                        value={'Yes'}
                                                                                        checked={qn.answer === 'Yes' ? "checked" : ''}
                                                                                        onChange={() => setAnswers(scopeIndex, catIndex, qnIndex, 'Yes')}
                                                                                    />
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label={t("No.label")}
                                                                                        name={`qn-${qn.id}`}
                                                                                        type="radio"
                                                                                        id={`inline-radio-${qn.id}-2`}
                                                                                        value={'No'}
                                                                                        checked={qn.answer === 'No' ? "checked" : ''}
                                                                                        onChange={() => setAnswers(scopeIndex, catIndex, qnIndex, 'No')}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {/* <div className='GHGOprBoundaries_footer text-right p-3'>
                                                <button className='btn btn-success'>{t("continue.label")}</button>
                                            </div> */}
                                        </Tab>
                                    )
                                })
                            }
                        </Tabs>
                    </div>
                    <div className='text-center p-2 pt-3 GHGInventory_cardFooter'>
                        <Button variant='secondary' className='px-4' onClick={() => saveOprBoundaries('back')}>{t('Back.label')}</Button>
                        {/* <Button variant='primary' className='px-4 mx-2' onClick={() => saveOprBoundaries()}>{t('Save.label')}</Button> */}
                        <Button variant='secondary' className='px-4 mx-2' onClick={() => saveOprBoundaries('next')}>{t('Next.label')}</Button>
                    </div>
                </div>
            </div>

        </div>
    )
};

export default withTranslation()(UAEFDLOprBoundaries);